import moment from "moment";

const EMPTY_STRING = "";

export function isToday(date) {
  return date.isSame(moment().startOf("day"), "d");
}

export function isYesterday(date) {
  return date.isSame(moment().subtract(1, "days").startOf("day"), "d");
}

export function dateFilter(date) {
  if (!date) {
    return EMPTY_STRING;
  }

  const momentDate = moment(date);

  let formattedDate = "";

  if (isToday(momentDate)) {
    formattedDate = momentDate.format("[Сегодня,] HH:mm");
  } else if (isYesterday(momentDate)) {
    formattedDate = momentDate.format("[Вчера, ] HH:mm");
  } else {
    formattedDate = momentDate.locale("ru").format("D MMMM YYYY, HH:mm");
  }

  return formattedDate;
}

export function msToMin(ms) {
  const seconds = Math.floor(ms / 1000) % 60;
  const minutes = Math.floor(ms / 1000 / 60) % 60;

  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedMinutes}:${formattedSeconds}`;
}

export function simpleDate(date) {
  if (!date) {
    return "";
  }

  return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY");
}

export function simpleDateWithTime(date) {
  if (!date) {
    return "";
  }

  return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY HH:mm");
}

export function onlyTime(date) {
  if (!date) {
    return "";
  }

  return moment(date, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
}

export function parseDate(date) {
  if (!date) {
    return "";
  }

  return moment(date, "DD.MM.YYYY HH:mm").format("YYYY-MM-DD HH:mm:ss");
}

export function parseOnlyDate(date) {
  if (!date) {
    return "";
  }

  return moment(date, "DD.MM.YYYY HH:mm").format("YYYY-MM-DD");
}

export function formatTimeToSeconds(time) {
  if (!time) {
    return "";
  }

  return moment(time, "HH:mm").format("HH:mm:ss");
}

export function days(daysCount) {
  let modulo = daysCount % 10;

  if (modulo === 1) {
    return `${daysCount} день`;
  } else if (modulo < 5 && modulo > 1) {
    return `${daysCount} дня`;
  } else {
    return `${daysCount} дней`;
  }
}

export function secondsToMinutes(seconds) {
  const secs = Math.floor(seconds % 60);
  const mins = Math.floor((seconds / 60) % 60);

  const formattedSeconds = secs < 10 ? `0${secs}` : secs;
  const formattedMinutes = mins < 10 ? `0${mins}` : mins;

  return `${formattedMinutes}:${formattedSeconds}`;
}

export default {
  dateFilter,
  msToMin,
  simpleDate,
  simpleDateWithTime,
  days,
  secondsToMinutes,
  parseDate,
  onlyTime,
  parseOnlyDate,
  formatTimeToSeconds
};
